import styled, {css} from "styled-components"

import {Body} from "@irati/ui/src/Typography"

export const SaveMore = styled(Body)`
  display: flex;
  align-items: center;
  ${({theme}) => css`
    background-color: ${theme.colors.secondary1};
    padding: 0 ${theme.spacing.one};
    border-radius: ${theme.spacing.half};
    color: ${theme.colors.utility.ink};
  `}
`
